import {
  any,
  filter,
  flatten,
  head,
  map,
  pipe,
  pluck,
  propEq,
  uniq,
} from "ramda";
import type { IEntity } from "interfaces/app";

const pluckEntityStores = pipe<IBrandGroup[], IEntity[][], IEntity[]>(
  pluck("stores"),
  flatten as (entities: IEntity[][]) => IEntity[]
);

const getPreferredStoreId = (brand?: IBrandGroup): string => {
  const stores = brand ? pluckEntityStores([brand]) : [];
  if (stores.length) {
    // FIXME - Track the store the user last interacted with,
    // or more robust way to determine relevant storeId.
    const firstStore = head(stores);
    return firstStore ? firstStore.id : "";
  }
  return "";
};

const isAdminAnywhere = ({ stores }: IBrandGroup) => {
  return any(({ apps }) => any(propEq("isAdmin", true), apps), stores);
};

const isolateBrandIds = (entities: IEntity[]): string[] => {
  return uniq(pluck<"brandId", string>("brandId", entities));
};

const isolateBrandNames = (entities: IEntity[]): string[] => {
  return uniq(pluck<"brandName", string>("brandName", entities));
};

interface IBrandGroup {
  brand: string;
  brandId: string;
  stores: IEntity[];
}

const isolateBrandStores =
  (entities: IEntity[]) =>
  (brandId: string): IBrandGroup => {
    const brandStores: IEntity[] = filter(propEq("brandId", brandId), entities);

    return {
      brand: brandStores[0].brandName,
      brandId,
      stores: brandStores,
    };
  };

const sortEntitiesByBrand = (entities: IEntity[]): IBrandGroup[] => {
  const brandIds: string[] = isolateBrandIds(entities);
  return map(isolateBrandStores(entities), brandIds);
};

export {
  getPreferredStoreId,
  IBrandGroup,
  isAdminAnywhere,
  isolateBrandNames,
  isolateBrandIds,
  pluckEntityStores,
  sortEntitiesByBrand,
};
